import * as React from 'react';
import Button from '@mui/material/Button';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, IconButton, Modal, Typography } from '@mui/material';
import { useSpring, animated } from '@react-spring/web';
import PropTypes from 'prop-types';
import Backdrop from '@mui/material/Backdrop';
import Image from 'mui-image';
import Close from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';



const Fade = React.forwardRef(function Fade(props, ref) {
    const {
        children,
        in: open,
        onClick,
        onEnter,
        onExited,
        ownerState,
        ...other
    } = props;
    const style = useSpring({
        from: { opacity: 0 },
        to: { opacity: open ? 1 : 0 },
        onStart: () => {
            if (open && onEnter) {
                onEnter(null, true);
            }
        },
        onRest: () => {
            if (!open && onExited) {
                onExited(null, true);
            }
        },
    });

    return (
        <animated.div ref={ref} style={style} {...other}>
            {React.cloneElement(children, { onClick })}
        </animated.div>
    );
});

Fade.propTypes = {
    children: PropTypes.element.isRequired,
    in: PropTypes.bool,
    onClick: PropTypes.any,
    onEnter: PropTypes.func,
    onExited: PropTypes.func,
    ownerState: PropTypes.any,
};

export default function AboutMe(props) {
    const onButtonClick = () => {
        fetch('resume.pdf').then(response => {
            response.blob().then(blob => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement('a');
                alink.href = fileURL;
                alink.download = 'Mann_Resume.pdf';
                alink.click();
            })
        })
    }
    var open = props.open;
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClose = () => {
        props.setOpen();
    };

    return (
        <div>
            <Modal className='no-overflow'
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        TransitionComponent: Fade,
                    },
                }}
                aria-labelledby="about-me"
                align="center"
                sx={{ maxHeight: "100vh" }}
            >
                <Fade in={open}>
                    <Box sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: { xs: "100vw", md: "90vw", lg: "75vw" },
                        height: "100vh",
                        bgcolor: '#282A3A',
                        border: "1px solid gold",
                        boxShadow: 24,
                        p: 4,
                        color: "white"
                    }} className='no-overflow'>
                        <IconButton sx={{
                            position: "relative",
                            float: "right",
                            background: "transparent",
                            color: "white",
                            top: "-10px",
                            right: "-10px",
                            fontSize: "1rem",
                            borderRadius: 50,
                            width: "fit-content",
                            height: "fit-content",
                        }} onClick={handleClose}>
                            <Close></Close>
                        </IconButton>
                        <Grid className='no-overflow' container spacing={2} direction="row" justifyContent="center" alignItems="center" maxHeight="100vh" minHeight="75vh" id="work" >
                            <Grid className='no-overflow' item width="100%" textAlign="left">
                                <Box className='no-overflow' sx={{ flexGrow: 1, display: { xs: 'block', md: "flex", lg: 'flex' }, flexDirection: "row", m: "auto", justifyContent: "center", alignContent: "center", alignItems: "center", height: "100%" }}>
                                    <Box className='no-overflow' sx={{ textAlign: "left", color: "white", height: "100%", alignItems: "start", width: "100%", p: { xs: "1rem", md: "3rem", lg: "3rem" }, ml: "auto", pr: "0rem" }}>
                                        <Typography className='no-overflow' variant="h3" sx={{
                                            display: { xs: 'block', md: "flex", lg: 'flex' },
                                            fontFamily: 'Title',
                                            fontSize: { xs: 30, md: 40, lg: 50 },
                                            letterSpacing: { xs: '0rem', md: "0.1rem", lg: '.1rem' },
                                            color: 'inherit',
                                            textDecoration: 'none',
                                            textAlign: { xs: "center", md: "left", lg: "left" },
                                            textTransform: "capitalize",
                                        }} gutterBottom
                                        >A developer & gamer by heart</Typography>
                                        <Typography className='no-overflow' sx={{
                                            display: { xs: 'block', md: "flex", lg: 'flex' },
                                            fontFamily: 'Title',
                                            fontSize: { xs: "1.25rem", md: "1.5rem", lg: "1.5rem" },
                                            letterSpacing: { xs: '0rem', md: "0.1rem", lg: '.1rem' },
                                            color: '#ECBC55',
                                            textDecoration: 'none',
                                            textAlign: { xs: "center", md: "left", lg: "left" },
                                            textTransform: "capitalize"
                                        }} gutterBottom>Hello!</Typography>
                                        <Typography className='no-overflow' sx={{
                                            display: { xs: 'block', md: "flex", lg: 'flex' },
                                            fontFamily: 'Title',
                                            fontSize: { xs: "1.25rem", md: "1.5rem", lg: "1.5rem" },
                                            letterSpacing: { xs: '0rem', md: "0.1rem", lg: '.1rem' },
                                            color: 'inherit',
                                            textDecoration: 'none',
                                            textAlign: { xs: "center", md: "left", lg: "left" },
                                            lineHeight: "2rem"
                                        }} >My name is Mann Bhanushali. I am an Aspiring ML Engineer in love with the possibilities of achieving great things with it. I develop Games as a hobby and know Web Development through the MERN Stack too!</Typography>
                                    </Box>
                                    <Image src={require('../images/pp.jpg')} alt="Image" sx={{ padding: { xs: "1rem", md: "5rem", lg: "5rem" }, mr: { xs: "0", md: "auto", lg: "auto" }, transition: "none !important", pl: "0.5rem", maxHeight: { xs: "12rem", md: "50rem", lg: "50rem" }, maxWidth: { xs: "12rem", md: "100rem", lg: "100rem" } }} />
                                    <IconButton onClick={onButtonClick} sx={{
                                        position: "absolute",
                                        textAlign: "center",
                                        alignSelf: "center",
                                        width: { xs: "100%", md: "fit-content", lg: "fit-content" },
                                        m: "auto",
                                        top: {xs:"95%",md:"90%",lg:"90%"},
                                        left: { xs: "0%", md: "auto", lg: "auto" },
                                        background: "transparent",
                                        color: "white",
                                        borderRadius:10,
                                        ":hover": {
                                            backgroundColor: "#FDDF9E", color: "#1D1F2A",
                                        },
                                        ":active":{
                                            backgroundColor: "white", color: "black",
                                        }
                                    }}>
                                        <DownloadIcon sx={{ fontSize: 30 }}></DownloadIcon>
                                        <Typography display={fullScreen?"none":"inline"}>&nbsp;&nbsp;Download Resume</Typography>
                                    </IconButton>
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Fade>
            </Modal>
        </div>
    );
}